// Données statiques : administrations, démarches, guides logement.
// Logos servis via Clearbit (publics) avec favicon Google en fallback côté composant.

export const ADMINISTRATIONS = [
  {
    id: "caf",
    name: "CAF",
    tagline: "Aides au logement (APL), aide sociale étudiante",
    url: "https://www.caf.fr/allocataires/mon-compte",
    logo: "https://icons.duckduckgo.com/ip3/caf.fr.ico",
    category: "Aides",
  },
  {
    id: "crous",
    name: "CROUS",
    tagline: "Bourses, logement étudiant, restauration",
    url: "https://www.etudiant.gouv.fr",
    logo: "https://icons.duckduckgo.com/ip3/etudiant.gouv.fr.ico",
    category: "Études",
  },
  {
    id: "ameli",
    name: "Ameli (CPAM)",
    tagline: "Sécurité sociale étudiante, carte Vitale",
    url: "https://www.ameli.fr",
    logo: "https://icons.duckduckgo.com/ip3/ameli.fr.ico",
    category: "Santé",
  },
  {
    id: "ants",
    name: "ANTS",
    tagline: "Titres sécurisés : carte d'identité, passeport, permis, titre de séjour",
    url: "https://ants.gouv.fr",
    logo: "https://icons.duckduckgo.com/ip3/ants.gouv.fr.ico",
    category: "Papiers",
  },
  {
    id: "prefecture",
    name: "Préfecture",
    tagline: "Titre de séjour, démarches administratives",
    url: "https://www.interieur.gouv.fr",
    logo: "https://icons.duckduckgo.com/ip3/interieur.gouv.fr.ico",
    category: "Papiers",
  },
  {
    id: "impots",
    name: "Impôts.gouv",
    tagline: "Déclaration d'impôts, avis de situation",
    url: "https://www.impots.gouv.fr",
    logo: "https://icons.duckduckgo.com/ip3/impots.gouv.fr.ico",
    category: "Impôts",
  },
  {
    id: "sncf",
    name: "SNCF Connect",
    tagline: "Carte Avantage Jeune, TGV, abonnements",
    url: "https://www.sncf-connect.com",
    logo: "https://icons.duckduckgo.com/ip3/sncf.com.ico",
    category: "Transport",
  },
  {
    id: "ratp",
    name: "RATP",
    tagline: "Imagine R, Navigo étudiant (Île-de-France)",
    url: "https://www.ratp.fr",
    logo: "https://icons.duckduckgo.com/ip3/ratp.fr.ico",
    category: "Transport",
  },
  {
    id: "pole-emploi",
    name: "France Travail",
    tagline: "Recherche d'emploi, stages, alternance",
    url: "https://www.francetravail.fr",
    logo: "https://icons.duckduckgo.com/ip3/francetravail.fr.ico",
    category: "Emploi",
  },
  {
    id: "service-public",
    name: "Service-Public.fr",
    tagline: "Portail officiel de l'administration française",
    url: "https://www.service-public.fr",
    logo: "https://icons.duckduckgo.com/ip3/service-public.fr.ico",
    category: "Général",
  },
  {
    id: "campus-france",
    name: "Campus France",
    tagline: "Étudiants internationaux : visas, études en France",
    url: "https://www.campusfrance.org",
    logo: "https://icons.duckduckgo.com/ip3/campusfrance.org.ico",
    category: "International",
  },
  {
    id: "mesr",
    name: "Ministère Enseignement Sup.",
    tagline: "Informations officielles étudiants",
    url: "https://www.enseignementsup-recherche.gouv.fr",
    logo: "https://icons.duckduckgo.com/ip3/enseignementsup-recherche.gouv.fr.ico",
    category: "Études",
  },
];

export const HOUSING_ORGS = [
  {
    id: "dossierfacile",
    name: "DossierFacile (Mon Dossier Facile)",
    tagline: "Service public · Constituez un dossier de location numérique certifié par l'État",
    url: "https://www.dossierfacile.logement.gouv.fr",
    logo: "https://icons.duckduckgo.com/ip3/dossierfacile.logement.gouv.fr.ico",
    highlight: true,
  },
  {
    id: "yellom",
    name: "Yellom",
    tagline: "Colocation & logements étudiants vérifiés",
    url: "https://www.yellome.fr",
    logo: "https://icons.duckduckgo.com/ip3/yellome.fr.ico",
  },
  {
    id: "lokaviz",
    name: "Lokaviz (CROUS)",
    tagline: "Plateforme publique de logements étudiants labellisés",
    url: "https://www.lokaviz.fr",
    logo: "https://icons.duckduckgo.com/ip3/lokaviz.fr.ico",
  },
  {
    id: "studapart",
    name: "Studapart",
    tagline: "Logements étudiants, garant intégré",
    url: "https://www.studapart.com",
    logo: "https://icons.duckduckgo.com/ip3/studapart.com.ico",
  },
  {
    id: "adele",
    name: "Adele.org",
    tagline: "Résidences étudiantes privées",
    url: "https://www.adele.org",
    logo: "https://icons.duckduckgo.com/ip3/adele.org.ico",
  },
  {
    id: "visale",
    name: "Visale (Action Logement)",
    tagline: "Garant gratuit pour étudiants et jeunes",
    url: "https://www.visale.fr",
    logo: "https://icons.duckduckgo.com/ip3/visale.fr.ico",
  },
  {
    id: "locservice",
    name: "LocService",
    tagline: "Location directe entre particuliers sans agence",
    url: "https://www.locservice.fr",
    logo: "https://icons.duckduckgo.com/ip3/locservice.fr.ico",
  },
  {
    id: "leboncoin",
    name: "Le Bon Coin",
    tagline: "Annonces entre particuliers (vigilance arnaques)",
    url: "https://www.leboncoin.fr",
    logo: "https://icons.duckduckgo.com/ip3/leboncoin.fr.ico",
  },
];

export const HOUSING_MISTAKES = [
  {
    title: "Commencer à visiter sans dossier prêt",
    detail: "Préparez votre dossier complet (DossierFacile) AVANT de visiter. Les biens partent en quelques heures.",
  },
  {
    title: "Envoyer de l'argent avant signature du bail",
    detail: "Jamais d'acompte ou de caution avant d'avoir signé un bail et visité physiquement le logement.",
  },
  {
    title: "Ignorer le diagnostic DPE et les charges",
    detail: "Un logement G ou F peut faire exploser votre facture. Demandez toujours l'estimation des charges.",
  },
  {
    title: "Ne pas lire le bail en entier",
    detail: "Vérifiez durée, dépôt de garantie (max 1 mois pour vide, 2 mois meublé), clauses abusives.",
  },
  {
    title: "Choisir sans garant (ou sans Visale)",
    detail: "La garantie Visale est gratuite et acceptée par la plupart des bailleurs. Activez-la en amont.",
  },
  {
    title: "Tomber dans les fausses annonces",
    detail: "Méfiez-vous des prix trop bas, propriétaires à l'étranger, paiement par mandat Western Union.",
  },
  {
    title: "Oublier l'assurance habitation",
    detail: "Obligatoire avant la remise des clés. Comparez, les assurances étudiantes démarrent autour de 3 €/mois.",
  },
  {
    title: "Ne pas faire d'état des lieux détaillé",
    detail: "Photos, vidéos, mentions écrites de chaque défaut. Cela vous protège lors du départ.",
  },
];

export const AGENCIES_WARNING = {
  title: "Agences immobilières : vigilance",
  body: "Aucune liste officielle n'existe. Avant de signer, vérifiez toujours : la carte professionnelle (obligatoire, à demander), les avis Google/Trustpilot, l'inscription à la FNAIM ou SNPI, et les frais d'agence (plafonnés par la loi ALUR selon la zone). Signalez tout comportement abusif à la DGCCRF (SignalConso).",
  redFlags: [
    "Frais d'agence ou de dossier payés avant la signature du bail",
    "Refus de fournir la carte professionnelle (carte T)",
    "Pression à la signature rapide sans délai de réflexion",
    "Frais cachés ou surfacturation en zone tendue",
    "Pas d'adresse physique ou avis majoritairement négatifs",
    "Demande de caution cash ou virement à un particulier",
  ],
  report: "https://signal.conso.gouv.fr",
};

export const DEMARCHES = [
  { id: "d-dossierfacile", title: "Créer mon dossier DossierFacile", category: "Logement", priority: 1, description: "Certifier tous mes justificatifs (RIB, avis, garant)" },
  { id: "d-visale", title: "Activer la garantie Visale", category: "Logement", priority: 2, description: "Garant gratuit pour étudiants" },
  { id: "d-bail", title: "Signer mon bail et faire l'état des lieux", category: "Logement", priority: 3 },
  { id: "d-assurance", title: "Souscrire une assurance habitation", category: "Logement", priority: 4 },
  { id: "d-caf", title: "Demander l'APL sur le site CAF", category: "Aides", priority: 5 },
  { id: "d-bourse", title: "Faire mon Dossier Social Étudiant (DSE)", category: "Aides", priority: 6, description: "Bourse CROUS + logement" },
  { id: "d-ameli", title: "Mettre à jour mon dossier Ameli / carte Vitale", category: "Santé", priority: 7 },
  { id: "d-mutuelle", title: "Souscrire une mutuelle étudiante", category: "Santé", priority: 8 },
  { id: "d-carte-etu", title: "Récupérer ma carte étudiante", category: "Études", priority: 9 },
  { id: "d-izly", title: "Activer mon compte Izly (restaurants CROUS)", category: "Études", priority: 10 },
  { id: "d-imagine-r", title: "Commander Imagine R / Navigo étudiant", category: "Transport", priority: 11 },
  { id: "d-sncf", title: "Acheter la carte Avantage Jeune SNCF", category: "Transport", priority: 12 },
  { id: "d-banque", title: "Ouvrir un compte bancaire étudiant", category: "Vie pratique", priority: 13 },
  { id: "d-impots", title: "Déclarer mes revenus (ou être rattaché)", category: "Impôts", priority: 14 },
  { id: "d-titre-sejour", title: "Renouveler mon titre de séjour (si concerné)", category: "International", priority: 15 },
];

export const DOCUMENT_CATEGORIES = [
  "Identité",
  "Logement",
  "Bourse / CAF",
  "Santé",
  "Études",
  "Impôts",
  "Autre",
];

export const STATUS_LABELS = {
  not_started: "À faire",
  in_progress: "En cours",
  done: "Terminé",
};

export const PSY_RESOURCES = [
  {
    id: "fil-sante-jeunes",
    name: "Fil Santé Jeunes",
    tagline: "Anonyme, gratuit · 7j/7 de 9h à 23h",
    url: "https://www.filsantejeunes.com",
    logo: "https://icons.duckduckgo.com/ip3/filsantejeunes.com.ico",
    contact: "0 800 235 236",
  },
  {
    id: "nightline",
    name: "Nightline France",
    tagline: "Écoute étudiante anonyme · Tous les soirs 21h-2h30",
    url: "https://www.nightline.fr",
    logo: "https://icons.duckduckgo.com/ip3/nightline.fr.ico",
    contact: "05 82 95 10 11",
  },
  {
    id: "santepsy",
    name: "Mon Soutien Psy",
    tagline: "8 séances remboursées par la Sécu (sans avance de frais)",
    url: "https://www.monsoutienpsy.ameli.fr",
    logo: "https://icons.duckduckgo.com/ip3/ameli.fr.ico",
  },
  {
    id: "santepsy-etu",
    name: "Santé Psy Étudiant",
    tagline: "12 séances de psy gratuites par an (sur prescription)",
    url: "https://santepsyetudiant.fr",
    logo: "https://icons.duckduckgo.com/ip3/santepsyetudiant.fr.ico",
  },
  {
    id: "sos-amitie",
    name: "SOS Amitié",
    tagline: "Écoute anonyme 24h/24, par téléphone et tchat",
    url: "https://www.sos-amitie.com",
    logo: "https://icons.duckduckgo.com/ip3/sos-amitie.com.ico",
    contact: "09 72 39 40 50",
  },
  {
    id: "3114",
    name: "3114 — Prévention suicide",
    tagline: "Ligne nationale, gratuite, 24h/24, professionnels formés",
    url: "https://3114.fr",
    logo: "https://icons.duckduckgo.com/ip3/3114.fr.ico",
    contact: "3114",
  },
  {
    id: "cmpp-bapu",
    name: "BAPU — Bureau d'Aide Psy Universitaire",
    tagline: "Consultations gratuites en ville pour étudiants (16-30 ans)",
    url: "https://www.fnabapu.fr",
    logo: "https://icons.duckduckgo.com/ip3/fnabapu.fr.ico",
  },
  {
    id: "soss",
    name: "SOS Médecins",
    tagline: "Médecins de garde, à domicile · 24h/24",
    url: "https://www.sosmedecins-france.fr",
    logo: "https://icons.duckduckgo.com/ip3/sosmedecins-france.fr.ico",
    contact: "3624",
  },
];

export const SAFE_EXCHANGE = [
  {
    id: "bu",
    title: "Bibliothèques universitaires (BU)",
    detail: "Espaces silencieux et de coworking, gratuit avec ta carte étudiante. Idéal pour réviser à plusieurs.",
  },
  {
    id: "crous-cafet",
    title: "Cafétérias & RU CROUS",
    detail: "Lieux conviviaux et abordables (3,30 €). Sécurisés, fréquentés, surveillance.",
  },
  {
    id: "asso-bde",
    title: "BDE & associations étudiantes",
    detail: "Rejoins le BDE de ton école : sorties encadrées, soirées sans pression, entraide.",
  },
  {
    id: "tiers-lieux",
    title: "Tiers-lieux & maisons des étudiants",
    detail: "Espaces gratuits dans la plupart des grandes villes pour bosser, échanger, organiser des événements.",
  },
  {
    id: "study-coffee",
    title: "Cafés 'study-friendly'",
    detail: "Recherche 'café coworking étudiant + ta ville' : connexion, prises et silence garantis.",
  },
  {
    id: "parc-jour",
    title: "Parcs et campus le jour",
    detail: "Pour décompresser entre amis. Évite les zones isolées la nuit, privilégie les lieux fréquentés.",
  },
];

export const PREVENTION_ALCOOL = [
  {
    id: "alc-1",
    title: "Connais tes limites",
    detail: "2 verres standards / jour max, pas tous les jours, jamais en binge-drinking. 1 verre = 10 g d'alcool pur.",
  },
  {
    id: "alc-2",
    title: "Ne mélange pas",
    detail: "Alcool + médicaments + stupéfiants = cocktail très dangereux (overdose, blackout, malaise).",
  },
  {
    id: "alc-3",
    title: "Surveille ton verre",
    detail: "GHB & autres drogues du violeur : ne laisse jamais ton verre sans surveillance, même chez des amis.",
  },
  {
    id: "alc-4",
    title: "Rentrer en sécurité",
    detail: "Prévois ton retour avant : Uber, Bolt, transports en commun, retour à plusieurs. Évite la marche seule la nuit.",
  },
  {
    id: "alc-5",
    title: "Ressources et écoute",
    detail: "Drogues Info Service · 0 800 23 13 13 (24h/24, gratuit, anonyme). Alcool Info Service · 0 980 980 930.",
  },
];

export const PREVENTION_LINKS = [
  {
    id: "drogues-info",
    name: "Drogues Info Service",
    tagline: "0 800 23 13 13 · anonyme, gratuit · 7j/7 · 8h-2h",
    url: "https://www.drogues-info-service.fr",
    logo: "https://icons.duckduckgo.com/ip3/drogues-info-service.fr.ico",
  },
  {
    id: "alcool-info",
    name: "Alcool Info Service",
    tagline: "0 980 980 930 · anonyme, gratuit · 7j/7 · 8h-2h",
    url: "https://www.alcool-info-service.fr",
    logo: "https://icons.duckduckgo.com/ip3/alcool-info-service.fr.ico",
  },
  {
    id: "tabac-info",
    name: "Tabac Info Service",
    tagline: "39 89 · accompagnement à l'arrêt · lun-sam 8h-20h",
    url: "https://www.tabac-info-service.fr",
    logo: "https://icons.duckduckgo.com/ip3/tabac-info-service.fr.ico",
  },
  {
    id: "info-violences",
    name: "3919 — Violences Femmes Info",
    tagline: "Anonyme, gratuit, 24h/24",
    url: "https://arretonslesviolences.gouv.fr",
    logo: "https://icons.duckduckgo.com/ip3/arretonslesviolences.gouv.fr.ico",
    contact: "3919",
  },
];

export const TOOLS = [
  {
    id: "canva-edu",
    name: "Canva Education",
    tagline: "Canva Pro gratuit pour étudiants — CV, présentations, posts, modèles pros",
    url: "https://www.canva.com/fr_fr/education/etudiants/#templates",
    logo: "https://icons.duckduckgo.com/ip3/canva.com.ico",
  },
  {
    id: "notion",
    name: "Notion",
    tagline: "Notes, projets, planning étudiant. Plan Education gratuit avec ton email .edu",
    url: "https://www.notion.com/fr/students",
    logo: "https://icons.duckduckgo.com/ip3/notion.so.ico",
  },
  {
    id: "google-maps",
    name: "Google Maps",
    tagline: "Itinéraires, lieux, transports, photos",
    url: "https://maps.google.com",
    logo: "https://icons.duckduckgo.com/ip3/maps.google.com.ico",
  },
  {
    id: "waze",
    name: "Waze",
    tagline: "Navigation communautaire en temps réel",
    url: "https://www.waze.com",
    logo: "https://icons.duckduckgo.com/ip3/waze.com.ico",
  },
  {
    id: "calendly",
    name: "Calendly",
    tagline: "Prends et planifie tes rendez-vous facilement",
    url: "https://calendly.com",
    logo: "https://icons.duckduckgo.com/ip3/calendly.com.ico",
  },
];

// Assurances habitation étudiantes
export const HOUSING_INSURANCE = [
  {
    id: "lmde",
    name: "LMDE",
    tagline: "Mutuelle étudiante : assurance habitation à partir de 3 €/mois",
    url: "https://www.lmde.fr",
    logo: "https://icons.duckduckgo.com/ip3/lmde.fr.ico",
  },
  {
    id: "heyme",
    name: "HEYME",
    tagline: "Couverture étudiante complète, devis en ligne",
    url: "https://www.heyme.care",
    logo: "https://icons.duckduckgo.com/ip3/heyme.care.ico",
  },
  {
    id: "matmut",
    name: "Matmut",
    tagline: "Offre étudiante avec garantie scolaire incluse",
    url: "https://www.matmut.fr",
    logo: "https://icons.duckduckgo.com/ip3/matmut.fr.ico",
  },
  {
    id: "maif",
    name: "MAIF",
    tagline: "Assurance habitation responsable, tarifs jeunes",
    url: "https://www.maif.fr",
    logo: "https://icons.duckduckgo.com/ip3/maif.fr.ico",
  },
  {
    id: "macif",
    name: "Macif",
    tagline: "Forfait habitation jeune, multi-équipements",
    url: "https://www.macif.fr",
    logo: "https://icons.duckduckgo.com/ip3/macif.fr.ico",
  },
  {
    id: "smeno",
    name: "SMENO",
    tagline: "Mutuelle étudiante du Nord, habitation incluse",
    url: "https://www.smeno.com",
    logo: "https://icons.duckduckgo.com/ip3/smeno.com.ico",
  },
  {
    id: "luko",
    name: "Luko",
    tagline: "Assurance 100 % en ligne, résiliation simple, 4 €/mois",
    url: "https://www.luko.eu",
    logo: "https://icons.duckduckgo.com/ip3/luko.eu.ico",
  },
  {
    id: "lovys",
    name: "Lovys",
    tagline: "Mensuel, sans engagement, 100 % digital",
    url: "https://www.lovys.com",
    logo: "https://icons.duckduckgo.com/ip3/lovys.com.ico",
  },
];

export const INSURANCE_TIPS = [
  "Compare au moins 3 devis : ne prends jamais le 1er proposé par le bailleur ou l'agence.",
  "Vérifie la franchise (somme à ta charge en cas de sinistre) — moins elle est élevée, mieux c'est.",
  "Garantie 'risques locatifs' minimum, mais une 'multirisque' protège tes affaires (vol, vandalisme, dégât des eaux).",
  "Demande l'attestation d'assurance avant la remise des clés — tu en as besoin pour signer.",
  "Tu peux résilier à tout moment après 1 an (loi Hamon).",
];

// Banques étudiantes
export const STUDENT_BANKS = [
  {
    id: "boursobank",
    name: "BoursoBank",
    tagline: "100 % en ligne · Carte gratuite · Bonus 80-150 € à l'ouverture",
    url: "https://www.boursobank.com",
    logo: "https://icons.duckduckgo.com/ip3/boursobank.com.ico",
    perks: ["Carte Visa gratuite", "Aucun frais de tenue", "Virements SEPA gratuits"],
  },
  {
    id: "hellobank",
    name: "Hello Bank!",
    tagline: "By BNP Paribas · Carte gratuite + appli reconnue",
    url: "https://www.hellobank.fr",
    logo: "https://icons.duckduckgo.com/ip3/hellobank.fr.ico",
    perks: ["Carte Visa Hello One gratuite", "Adossée à BNP", "Retraits gratuits"],
  },
  {
    id: "revolut",
    name: "Revolut",
    tagline: "Multi-devises · Idéal voyages et étudiants internationaux",
    url: "https://www.revolut.com",
    logo: "https://icons.duckduckgo.com/ip3/revolut.com.ico",
    perks: ["Change sans frais", "IBAN FR/EU", "Cartes virtuelles instantanées"],
  },
  {
    id: "n26",
    name: "N26",
    tagline: "Banque mobile allemande, carte virtuelle instantanée",
    url: "https://n26.com/fr-fr",
    logo: "https://icons.duckduckgo.com/ip3/n26.com.ico",
    perks: ["Carte Mastercard gratuite", "Catégorisation auto", "Sous-comptes Espaces"],
  },
  {
    id: "bnp-esprit-libre",
    name: "BNP Esprit Libre Découverte",
    tagline: "Pack étudiant : carte + appli + facilité de caisse",
    url: "https://mabanque.bnpparibas/fr/jeune-etudiant/esprit-libre-decouverte",
    logo: "https://icons.duckduckgo.com/ip3/bnpparibas.com.ico",
  },
  {
    id: "sg-jazz",
    name: "Société Générale Jazz",
    tagline: "Pack jeune : compte + carte CB + assurances",
    url: "https://particuliers.sg.fr/jeunes",
    logo: "https://icons.duckduckgo.com/ip3/societegenerale.fr.ico",
  },
  {
    id: "lcl-essentiel",
    name: "LCL Essentiel Jeune",
    tagline: "Offre 18-24 ans : compte + carte + assurance moyens de paiement",
    url: "https://particuliers.lcl.fr/clientele-jeunes",
    logo: "https://icons.duckduckgo.com/ip3/lcl.fr.ico",
  },
  {
    id: "ce",
    name: "Caisse d'Épargne Étudiant",
    tagline: "Offre Carte Étudiante + prêt à taux préférentiel",
    url: "https://www.caisse-epargne.fr/etudiants",
    logo: "https://icons.duckduckgo.com/ip3/caisse-epargne.fr.ico",
  },
];

// Prêts étudiants à taux zéro / aidés
export const STUDENT_LOANS = [
  {
    id: "pret-garanti-etat",
    name: "Prêt étudiant garanti par l'État",
    tagline: "Jusqu'à 20 000 € sans caution ni garant — partenariat banques + BPI",
    url: "https://www.etudiant.gouv.fr/fr/pret-bancaire-etudiant-garanti-par-l-etat-376",
    logo: "https://icons.duckduckgo.com/ip3/etudiant.gouv.fr.ico",
    highlight: true,
  },
  {
    id: "ce-pret-etudiant",
    name: "Caisse d'Épargne — Prêt Étudiant",
    tagline: "Taux préférentiels, différé total possible jusqu'à 5 ans",
    url: "https://www.caisse-epargne.fr/etudiants/pret-etudiant",
    logo: "https://icons.duckduckgo.com/ip3/caisse-epargne.fr.ico",
  },
  {
    id: "bnp-pret",
    name: "BNP Paribas — Prêt Étudiant",
    tagline: "Jusqu'à 75 000 €, taux à partir de 0,90 % selon profil",
    url: "https://mabanque.bnpparibas/fr/jeune-etudiant/pret-etudiant",
    logo: "https://icons.duckduckgo.com/ip3/bnpparibas.com.ico",
  },
  {
    id: "sg-pret",
    name: "Société Générale — Prêt Étudiant",
    tagline: "Différé d'amortissement jusqu'à la fin des études",
    url: "https://particuliers.sg.fr/credits/pret-etudiant",
    logo: "https://icons.duckduckgo.com/ip3/societegenerale.fr.ico",
  },
  {
    id: "credit-mutuel",
    name: "Crédit Mutuel — Prêt Études",
    tagline: "Montants modulables, mensualités allégées pendant les études",
    url: "https://www.creditmutuel.fr/fr/particuliers/credits/pret-etudiant.html",
    logo: "https://icons.duckduckgo.com/ip3/creditmutuel.fr.ico",
  },
  {
    id: "credit-agricole",
    name: "Crédit Agricole — Prêt Étudiant",
    tagline: "Taux fixes, financement études + permis + ordi",
    url: "https://www.credit-agricole.fr/particulier/credit/pret-etudes.html",
    logo: "https://icons.duckduckgo.com/ip3/credit-agricole.fr.ico",
  },
];

export const LOAN_TIPS = [
  "Le prêt garanti par l'État ne nécessite ni caution ni garant — idéal si tes parents ne peuvent pas se porter garants.",
  "Demande TOUJOURS un différé total (tu rembourses APRÈS tes études) pour ne pas alourdir ton budget étudiant.",
  "Compare TAEG (taux annuel effectif global), pas juste le taux nominal — c'est lui qui inclut tous les frais.",
  "Lis les conditions de remboursement anticipé : sans frais c'est mieux.",
  "Ne contracte que ce dont tu as besoin — un prêt étudiant se rembourse 5-10 ans après le diplôme.",
];

// Jobs étudiants
export const JOB_PLATFORMS = [
  {
    id: "studentjob",
    name: "StudentJob",
    tagline: "Offres dédiées étudiants : CDD, été, à temps partiel",
    url: "https://www.studentjob.fr",
    logo: "https://icons.duckduckgo.com/ip3/studentjob.fr.ico",
  },
  {
    id: "jobetudiant",
    name: "JobEtudiant.net",
    tagline: "Petits boulots, jobs d'été, alternance",
    url: "https://www.jobetudiant.net",
    logo: "https://icons.duckduckgo.com/ip3/jobetudiant.net.ico",
  },
  {
    id: "iquesta",
    name: "Iquesta",
    tagline: "Stages et alternances en France et à l'international",
    url: "https://www.iquesta.com",
    logo: "https://icons.duckduckgo.com/ip3/iquesta.com.ico",
  },
  {
    id: "jobteaser",
    name: "JobTeaser",
    tagline: "Plateforme officielle de plus de 700 écoles, stages + 1ers emplois",
    url: "https://www.jobteaser.com",
    logo: "https://icons.duckduckgo.com/ip3/jobteaser.com.ico",
  },
  {
    id: "indeed",
    name: "Indeed",
    tagline: "Le plus grand moteur d'offres d'emploi",
    url: "https://www.indeed.fr",
    logo: "https://icons.duckduckgo.com/ip3/indeed.fr.ico",
  },
  {
    id: "wttj",
    name: "Welcome to the Jungle",
    tagline: "Offres avec coulisses des entreprises",
    url: "https://www.welcometothejungle.com",
    logo: "https://icons.duckduckgo.com/ip3/welcometothejungle.com.ico",
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    tagline: "Réseau pro · candidatures rapides + filtre stage/alternance",
    url: "https://www.linkedin.com/jobs",
    logo: "https://icons.duckduckgo.com/ip3/linkedin.com.ico",
  },
  {
    id: "francetravail",
    name: "France Travail",
    tagline: "Offres officielles + accompagnement gratuit",
    url: "https://candidat.francetravail.fr",
    logo: "https://icons.duckduckgo.com/ip3/francetravail.fr.ico",
  },
  {
    id: "youpijob",
    name: "YoupiJob",
    tagline: "Petits boulots ponctuels (déménagement, ménage, garde d'enfants)",
    url: "https://www.youpijob.fr",
    logo: "https://icons.duckduckgo.com/ip3/youpijob.fr.ico",
  },
  {
    id: "yoopies",
    name: "Yoopies",
    tagline: "Babysitting, soutien scolaire, aide à domicile",
    url: "https://yoopies.fr",
    logo: "https://icons.duckduckgo.com/ip3/yoopies.fr.ico",
  },
  {
    id: "stootie",
    name: "Stootie",
    tagline: "Mission rémunérées entre particuliers",
    url: "https://www.stootie.com",
    logo: "https://icons.duckduckgo.com/ip3/stootie.com.ico",
  },
  {
    id: "ubereats",
    name: "Uber Eats / Deliveroo",
    tagline: "Livraison à vélo / scooter, horaires flexibles",
    url: "https://www.uber.com/fr/fr/deliver",
    logo: "https://icons.duckduckgo.com/ip3/uber.com.ico",
  },
];

export const JOB_TIPS = [
  {
    title: "Un job, oui — mais 15h/semaine max",
    detail: "Au-delà, tes notes en pâtissent. Privilégie les jobs étudiants qui s'adaptent à ton emploi du temps.",
  },
  {
    title: "Ton CV en 1 page",
    detail: "Utilise Canva (gratuit), modèle simple, met en avant tes compétences ET tes expériences associatives.",
  },
  {
    title: "Lettre de motivation : 4 paragraphes",
    detail: "Pourquoi cette boîte / pourquoi toi / ce que tu apportes / appel à un entretien. 250 mots max.",
  },
  {
    title: "Active ton réseau",
    detail: "70 % des jobs étudiants se trouvent par bouche-à-oreille. Préviens BDE, profs, anciens stagiaires.",
  },
  {
    title: "Connais tes droits",
    detail: "SMIC horaire = 11,88 € brut (2026). Heures sup' majorées. Bulletin de paie obligatoire dès la 1ère heure.",
  },
];

// Budget & économies
export const MONEY_TIPS = [
  {
    id: "budget",
    title: "Suis ton budget chaque semaine",
    detail: "Apps gratuites : Bankin', Linxo, Revolut Pockets. La règle 50/30/20 (besoins/envies/épargne).",
  },
  {
    id: "courses",
    title: "Courses : RU, hard-discount et anti-gaspi",
    detail: "Resto U à 3,30 € (1 € si bourse). Lidl/Aldi/Action. Too Good To Go pour des paniers à 3-5 €.",
  },
  {
    id: "transports",
    title: "Transports : abonnements jeunes",
    detail: "Imagine R, Carte Avantage Jeune SNCF (-30 % toute l'année), BlaBlaCar, vélos en libre-service.",
  },
  {
    id: "logement",
    title: "Logement : APL + colocation",
    detail: "Demande l'APL dès le bail signé. Colocation = -40 % en moyenne sur le loyer + charges partagées.",
  },
  {
    id: "abonnements",
    title: "Réductions étudiantes systématiques",
    detail: "Spotify Étudiant (5,99 €/mois), Apple Music Étudiant, Amazon Prime Student gratuit 6 mois, Microsoft 365 gratuit avec mail école.",
  },
  {
    id: "loisirs",
    title: "Sorties à petit prix",
    detail: "Pass Culture (300 €), cinés -50 % en semaine, musées gratuits le 1er dimanche, festivals avec bénévolat.",
  },
  {
    id: "sante",
    title: "Santé : 100 % remboursé pour étudiants",
    detail: "Dentaire et lunettes : profite des forfaits 100 % santé. Mutuelle = négocie ou compare HEYME, LMDE.",
  },
  {
    id: "compte",
    title: "Compte épargne : Livret Jeune",
    detail: "Réservé aux 12-25 ans, taux > Livret A (3 %), plafond 1 600 €. À ouvrir sans hésiter.",
  },
];

export const SAVINGS_APPS = [
  { id: "toogood", name: "Too Good To Go", url: "https://toogoodtogo.com", logo: "https://icons.duckduckgo.com/ip3/toogoodtogo.com.ico", tagline: "Paniers anti-gaspi à -70 %" },
  { id: "phenix", name: "Phenix", url: "https://www.wearephenix.com", logo: "https://icons.duckduckgo.com/ip3/wearephenix.com.ico", tagline: "Anti-gaspi en supermarché" },
  { id: "vinted", name: "Vinted", url: "https://www.vinted.fr", logo: "https://icons.duckduckgo.com/ip3/vinted.fr.ico", tagline: "Achats / reventes seconde main" },
  { id: "leboncoin-buy", name: "Le Bon Coin", url: "https://www.leboncoin.fr", logo: "https://icons.duckduckgo.com/ip3/leboncoin.fr.ico", tagline: "Mobilier, électroménager, vélos" },
  { id: "bankin", name: "Bankin'", url: "https://bankin.com", logo: "https://icons.duckduckgo.com/ip3/bankin.com.ico", tagline: "Suivi budget multi-comptes" },
  { id: "linxo", name: "Linxo", url: "https://www.linxo.com", logo: "https://icons.duckduckgo.com/ip3/linxo.com.ico", tagline: "Gestion budget + alertes" },
  { id: "passculture", name: "Pass Culture", url: "https://pass.culture.fr", logo: "https://icons.duckduckgo.com/ip3/pass.culture.fr.ico", tagline: "300 € pour la culture (15-20 ans)" },
  { id: "unidays", name: "UNiDAYS", url: "https://www.myunidays.com", logo: "https://icons.duckduckgo.com/ip3/myunidays.com.ico", tagline: "Codes promos étudiants vérifiés" },
];

export const TESTIMONIALS = [
  {
    id: "leila",
    name: "Leïla, 21 ans",
    school: "Sciences Po Lille · L3",
    city: "Lille",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=faces",
    quote: "J'ai trouvé ma coloc en 4 jours grâce au DossierFacile préparé sur Student Hub. Le pack modèles m'a évité de faire 10 lettres à la main.",
    rating: 5,
  },
  {
    id: "yanis",
    name: "Yanis, 19 ans",
    school: "INSA Lyon · 1ère année",
    city: "Lyon",
    avatar: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=200&h=200&fit=crop&crop=faces",
    quote: "L'essai 7 jours m'a convaincu. La lettre de recours CAF dans Premium m'a permis de récupérer 480 € d'APL bloquée. Rentabilisé en une fois.",
    rating: 5,
  },
  {
    id: "amelie",
    name: "Amélie, 22 ans",
    school: "Université Paris Cité · M1 Droit",
    city: "Paris",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=faces",
    quote: "Je gère mes 14 démarches d'étudiante internationale au même endroit. La carte locale m'a fait découvrir le BAPU à côté de chez moi.",
    rating: 5,
  },
];
